var _path, _path2, _rect, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 123,
    viewBox: "0 0 380 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.311 120.629V0H323.697V65.2049H337.133L359.09 36.6777H378.589L350.406 73.6815L379.408 120.629H360.237L335.331 80.8541H323.697V120.629H307.311Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.459 120.629V36.6777H279.844V120.629H263.459Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 253.869,
    y: 0.10498,
    width: 34.8632,
    height: 20.8101,
    rx: 10.405,
    fill: "#009BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.066 120.629L194.922 77.9198L168.049 36.6777H186.729L206.555 67.4871L226.218 36.6777H245.226L218.189 77.5938L245.717 120.629H227.038L206.555 88.3526L186.073 120.629H167.066Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.879 122.096C91.9898 122.096 75.1125 103.187 75.1125 78.7347C75.1125 53.9569 92.1537 35.2104 117.715 35.2104C142.458 35.2104 158.024 54.6089 158.024 76.7786V84.4402H91.6621C93.7922 100.415 104.607 107.425 117.879 107.425C131.315 107.425 140 99.2743 142.622 91.9387L155.239 98.6222C151.634 107.914 140.164 122.096 117.879 122.096ZM92.1537 70.7471H140.983C140.819 60.3143 131.971 49.5555 117.551 49.5555C105.098 49.5555 94.9392 56.8911 92.1537 70.7471Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.117126 120.629V6.52051H16.9944V105.306H71.3949V120.629H0.117126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logoName.75a0cebdd5f06234b6a2d32bbe2c60ae.svg";
export { ForwardRef as ReactComponent };